class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};
    this.compactClass = 'giolippo-header--compact';

    this.setHeaderHeight();

    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    }

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    // Skip if menu is open - prevent hiding header when menu drawer is open
    if (this.header && this.header.classList.contains('menu-open')) {
      // When menu is open, ensure header is visible and remove hidden class
      this.header.classList.remove('shopify-section-header-hidden');
      this.header.classList.add('shopify-section-header-sticky');
      return;
    }

    // Skip if always sticky mode
    if (this.headerIsAlwaysSticky) {
      this.currentScrollTop = scrollTop;
      return;
    }

    // Determine scroll direction
    const isScrollingDown = scrollTop > this.currentScrollTop;
    const isScrollingUp = scrollTop < this.currentScrollTop;

    // At the very top: always show the header (remove sticky and hidden)
    if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.header.classList.remove(this.compactClass);
      this.currentScrollTop = scrollTop;
      this.preventReveal = false;
      return;
    }
    // Scrolling DOWN past the header: hide it
    else if (isScrollingDown && scrollTop > this.headerBounds.bottom) {
      if (!this.preventReveal) {
        this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      }
      // Add compact class when scrolled down
      if (scrollTop > this.headerBounds.bottom + 40) {
        this.header.classList.add(this.compactClass);
      }
    }
    // Scrolling UP past the header and not at the very bottom: show it
    else if (
      isScrollingUp &&
      scrollTop > this.headerBounds.bottom &&
      scrollTop + window.innerHeight < document.body.scrollHeight - 1
    ) {
      if (!this.preventReveal) {
        this.header.classList.add('shopify-section-header-sticky');
        this.header.classList.remove('shopify-section-header-hidden');
      }
      // Add compact class when scrolled past header
      if (scrollTop > this.headerBounds.bottom + 40) {
        this.header.classList.add(this.compactClass);
      } else {
        this.header.classList.remove(this.compactClass);
      }
    }
    // Handle compact class when scroll position changes but header visibility doesn't
    else {
      if (scrollTop > this.headerBounds.bottom + 40) {
        this.header.classList.add(this.compactClass);
      } else {
        this.header.classList.remove(this.compactClass);
      }
    }

    this.currentScrollTop = scrollTop;
    this.preventReveal = false;
  }
}

customElements.define('sticky-header', StickyHeader);
